import { render, staticRenderFns } from "./IconSpinMinusQuiz.vue?vue&type=template&id=bd576224&"
import script from "./IconSpinMinusQuiz.vue?vue&type=script&lang=js&"
export * from "./IconSpinMinusQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports